import { DeprecatedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import { additionalDataFactory } from './common/fieldsAdditionalData';
import {
    fieldsGlassWallClosingTypes,
    fieldsGlassWallDimension, fieldsGlassWallFrameMaterial, fieldsGlassWallOptions, fieldsGlassWallStyle, fieldsGlassWallWindowMaterial,
} from './common/fieldsGlassWalls';

const glassWallComplexForm: IForm = {
    formId       : DeprecatedFormId.GlassWallComplex,
    type         : FormTypeId.GlassWall,
    thumbnailURL : '/resized-images/forms/glassWallComplex.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.WindowMaterial,
        IFormFieldKey.FrameMaterial,
        IFormFieldKey.Dimension,
        IFormFieldKey.GlassWallStyle,
        IFormFieldKey.Openings,
        IFormFieldKey.ClosingType,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        windowMaterial : fieldsGlassWallWindowMaterial,
        frameMaterial  : fieldsGlassWallFrameMaterial,
        dimension      : fieldsGlassWallDimension,
        glassWallStyle : fieldsGlassWallStyle,
        openings       : fieldsGlassWallOptions,
        closingType    : fieldsGlassWallClosingTypes,
        additionalData : additionalDataFactory(),
        contact        : fieldsContact,
    },
};

export default glassWallComplexForm;
